import React from "react";
import { Link } from "react-router-dom";

export default function Home() {
  const mainModules = [
    { to: "/products", icon: "bi-box-seam", title: "المنتجات", desc: "تصفح وأدِر جميع المنتجات", color: "#2563eb" },
    { to: "/categories", icon: "bi-folder", title: "الأقسام", desc: "نظم المنتجات ضمن أقسام", color: "#8b5cf6" },
    { to: "/brands", icon: "bi-tag", title: "الماركات", desc: "عرض وإدارة الماركات", color: "#06b6d4" },
    { to: "/open-balance", icon: "bi-cash-coin", title: "الرصيد الافتتاحي", desc: "إعداد الرصيد الابتدائي للنظام", color: "#10b981" },
    { to: "/purchases", icon: "bi-cart-check", title: "ملخص المشتريات", desc: "عرض سجلات وتفاصيل المشتريات", color: "#f59e0b" },
    { to: "/create-purchase", icon: "bi-cart-plus", title: "شراء جديد", desc: "إضافة عملية شراء جديدة للنظام", color: "#f97316" },
    { to: "/sales", icon: "bi-receipt", title: "ملخص المبيعات", desc: "عرض سجلات وتفاصيل المبيعات", color: "#14b8a6" },
    { to: "/create-sale", icon: "bi-bag-plus", title: "بيع جديد", desc: "إضافة عملية بيع جديدة للنظام", color: "#22c55e" },
    { to: "/customers", icon: "bi-people", title: "العملاء", desc: "إدارة معلومات العملاء", color: "#3b82f6" },
    { to: "/suppliers", icon: "bi-truck", title: "الموردين", desc: "إدارة معلومات الموردين", color: "#6366f1" },
  ];

  const analysisModules = [
    { to: "/net", icon: "bi-graph-up-arrow", title: "صافي الربح", desc: "عرض ملخص الأرباح الكلية", color: "#16a34a" },
    { to: "/topprofits", icon: "bi-currency-dollar", title: "أعلى الأرباح", desc: "عرض العمليات ذات أعلى الأرباح", color: "#059669" },
    { to: "/topselling", icon: "bi-trophy", title: "الأكثر مبيعًا", desc: "عرض المنتجات الأكثر مبيعًا", color: "#f59e0b" },
    { to: "/topsupplier", icon: "bi-award", title: "أفضل الموردين", desc: "عرض الموردين الأعلى أداءً", color: "#8b5cf6" },
    { to: "/topcustomer", icon: "bi-star", title: "أفضل العملاء", desc: "عرض أفضل العملاء لديك", color: "#2563eb" },
    { to: "/inventoryvalue", icon: "bi-cash-stack", title: "قيمة المخزون", desc: "تقييم رأس المال والربح المتوقع", color: "#0891b2" }, // ✅ جديد
  ];

  return (
    <div className="container py-5" style={{ maxWidth: "1400px" }}>
      {/* Hero Section */}
      <div
        className="mb-5 mt-5 pt-5"
        style={{
          background: "linear-gradient(135deg, #2563eb 0%, #1e40af 100%)",
          borderRadius: "12px",
          padding: "60px 40px",
          textAlign: "center",
          boxShadow: "0 8px 24px rgba(37, 99, 235, 0.2)",
        }}
      >
        <h1 style={{ color: "#fff", fontSize: "46px", fontWeight: "700", marginBottom: "12px" }}>
          مرحبًا بك في نظام المخزون
        </h1>
        <p style={{ color: "rgba(255, 255, 255, 0.9)", fontSize: "20px", marginBottom: 0 }}>
          إدارة أعمالك بكفاءة مع أدواتنا المتكاملة
        </p>
      </div>

      {/* Divider */}
      <div
        style={{
          height: "1px",
          background: "linear-gradient(90deg, transparent, #cbd5e1, transparent)",
          margin: "60px 0",
        }}
      ></div>

      {/* Main Modules Section */}
      <div className="mb-5">
        <div
          className="d-flex align-items-center mb-4"
          style={{
            borderLeft: "4px solid #2563eb",
            paddingLeft: "16px",
          }}
        >
          <div>
            <h2 style={{ color: "#1e40af", fontSize: "30px", fontWeight: "700", marginBottom: "4px" }}>
              الوحدات الرئيسية
            </h2>
            <p style={{ color: "#64748b", fontSize: "16px", marginBottom: 0 }}>
              الميزات الأساسية للعمليات اليومية
            </p>
          </div>
        </div>

        <div className="row g-4">
          {mainModules.map((module, index) => (
            <div className="col-md-3 col-sm-6" key={index}>
              <Link to={module.to} style={{ textDecoration: "none" }}>
                <div
                  style={{
                    background: "#fff",
                    border: "1px solid #e2e8f0",
                    borderRadius: "8px",
                    padding: "24px",
                    height: "100%",
                    transition: "all 0.3s ease",
                    cursor: "pointer",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = "translateY(-4px)";
                    e.currentTarget.style.boxShadow = "0 8px 24px rgba(37, 99, 235, 0.15)";
                    e.currentTarget.style.borderColor = module.color;
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "0 2px 8px rgba(0, 0, 0, 0.05)";
                    e.currentTarget.style.borderColor = "#e2e8f0";
                  }}
                >
                  <div
                    style={{
                      width: "56px",
                      height: "56px",
                      borderRadius: "12px",
                      background: `${module.color}15`,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginBottom: "16px",
                    }}
                  >
                    <i
                      className={module.icon}
                      style={{ fontSize: "28px", color: module.color }}
                    ></i>
                  </div>
                  <h5
                    style={{
                      color: "#1e293b",
                      fontSize: "19px",
                      fontWeight: "700",
                      marginBottom: "8px",
                    }}
                  >
                    {module.title}
                  </h5>
                  <p
                    style={{
                      color: "#64748b",
                      fontSize: "15px",
                      marginBottom: 0,
                      lineHeight: "1.5",
                    }}
                  >
                    {module.desc}
                  </p>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>

      {/* Divider */}
      <div
        style={{
          height: "1px",
          background: "linear-gradient(90deg, transparent, #cbd5e1, transparent)",
          margin: "60px 0",
        }}
      ></div>

      {/* Analysis Section */}
      <div>
        <div
          className="d-flex align-items-center mb-4"
          style={{
            borderLeft: "4px solid #16a34a",
            paddingLeft: "16px",
          }}
        >
          <div>
            <h2 style={{ color: "#15803d", fontSize: "30px", fontWeight: "700", marginBottom: "4px" }}>
              التحليلات التجارية
            </h2>
            <p style={{ color: "#64748b", fontSize: "16px", marginBottom: 0 }}>
              رؤى وتقارير لتعزيز نمو عملك
            </p>
          </div>
        </div>

        <div className="row g-4">
          {analysisModules.map((module, index) => (
            <div className="col-md-4 col-sm-6" key={index}>
              <Link to={module.to} style={{ textDecoration: "none" }}>
                <div
                  style={{
                    background: "#fff",
                    border: "2px solid #e2e8f0",
                    borderRadius: "8px",
                    padding: "28px 24px",
                    height: "100%",
                    transition: "all 0.3s ease",
                    cursor: "pointer",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
                    position: "relative",
                    overflow: "hidden",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = "translateY(-4px)";
                    e.currentTarget.style.boxShadow = "0 12px 32px rgba(22, 163, 74, 0.2)";
                    e.currentTarget.style.borderColor = module.color;
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "0 2px 8px rgba(0, 0, 0, 0.05)";
                    e.currentTarget.style.borderColor = "#e2e8f0";
                  }}
                >
                  {/* Background Icon */}
                  <div
                    style={{
                      position: "absolute",
                      top: "-20px",
                      right: "-20px",
                      fontSize: "120px",
                      color: `${module.color}08`,
                      transform: "rotate(-15deg)",
                    }}
                  >
                    <i className={module.icon}></i>
                  </div>

                  {/* Content */}
                  <div style={{ position: "relative", zIndex: 1 }}>
                    <div
                      style={{
                        width: "64px",
                        height: "64px",
                        borderRadius: "16px",
                        background: `linear-gradient(135deg, ${module.color}, ${module.color}dd)`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: "20px",
                        boxShadow: `0 4px 12px ${module.color}40`,
                      }}
                    >
                      <i
                        className={module.icon}
                        style={{ fontSize: "32px", color: "#fff" }}
                      ></i>
                    </div>
                    <h5
                      style={{
                        color: "#1e293b",
                        fontSize: "21px",
                        fontWeight: "700",
                        marginBottom: "10px",
                      }}
                    >
                      {module.title}
                    </h5>
                    <p
                      style={{
                        color: "#64748b",
                        fontSize: "15px",
                        marginBottom: 0,
                        lineHeight: "1.6",
                      }}
                    >
                      {module.desc}
                    </p>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>

      {/* Divider */}
      <div
        style={{
          height: "1px",
          background: "linear-gradient(90deg, transparent, #cbd5e1, transparent)",
          margin: "60px 0",
        }}
      ></div>

      {/* Footer Stats */}
      <div
        style={{
          background: "#f8fafc",
          borderRadius: "12px",
          padding: "40px 32px",
          textAlign: "center",
          border: "1px solid #e2e8f0",
        }}
      >
        <div className="row">
          <div className="col-md-4">
            <div style={{ padding: "12px" }}>
              <i className="bi bi-speedometer2" style={{ fontSize: "38px", color: "#2563eb", marginBottom: "12px" }}></i>
              <h4 style={{ color: "#1e293b", fontSize: "21px", fontWeight: "700", marginBottom: "8px" }}>
                سريع وفعال
              </h4>
              <p style={{ color: "#64748b", fontSize: "15px", marginBottom: 0 }}>
                عمليات مبسطة وسلسة
              </p>
            </div>
          </div>
          <div className="col-md-4">
            <div style={{ padding: "12px" }}>
              <i className="bi bi-shield-check" style={{ fontSize: "38px", color: "#16a34a", marginBottom: "12px" }}></i>
              <h4 style={{ color: "#1e293b", fontSize: "21px", fontWeight: "700", marginBottom: "8px" }}>
                آمن وموثوق
              </h4>
              <p style={{ color: "#64748b", fontSize: "15px", marginBottom: 0 }}>
                بياناتك محمية
              </p>
            </div>
          </div>
          <div className="col-md-4">
            <div style={{ padding: "12px" }}>
              <i className="bi bi-graph-up" style={{ fontSize: "38px", color: "#f59e0b", marginBottom: "12px" }}></i>
              <h4 style={{ color: "#1e293b", fontSize: "21px", fontWeight: "700", marginBottom: 8 }}>
                تحليلات ذكية
              </h4>
              <p style={{ color: "#64748b", fontSize: "15px", marginBottom: 0 }}>
                اتخاذ قرارات قائمة على البيانات
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}